import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LanguageService } from '@shared/services/language.service';
import { Auction } from '../../articles-manager/interfaces/auction.interface';
import { ArticleService } from '../../articles-manager/services/article.service';

@Component({
  selector: 'app-search-certificate-dialog',
  templateUrl: './search-certificate-dialog.component.html',
  styleUrls: ['./search-certificate-dialog.component.scss']
})
@UntilDestroy()
export class SearchCertificateDialogComponent implements OnInit {

  searchCode: string = '';
  searchedAuction: Auction = {
    idAuction: -1,
    idAuctionType: 1,
    evidenceLevel: 1,
    isVisible: false,
    isCloned: false,
    idAuctionParent: null,
    idStatus: 5,
    statusDescription: "",
    startDate: "",
    durationMinutes: 0,
    startDateView: "",
    endDateView: "",
    basePrice: 0.0,
    reservePrice: 0,
    articleQty: 0,
    idEntitySeller: 1,
    entitySellerName: '',
    buyItNow: false,
    embeddedUrl: "",
    article: null,
    currentMaxOfferedPrice: null,
    currentMaxIDUserBidder: null,
    currentMaxUsernameBidder: null,
    currentUserOffered: false,
    totalBidder: null,
    totalBids: null,
    isFinished: false,
    idUserWinner: null,
    winnerPrice: null,
    idAutoRebid: null,
    rebidMaxOfferPrice: null,
    idCampaign: null,
    idPromoter: null,
    fullCampaignEntityLogoPath: "",
    fullPromoterLogoPath: "",
    campaignTitleList: [],
    promoterTitleList: [],
    hasReservePrice: false,
    reservePriceReached: false,
    winnerUsername: '',
    idEvent: null,
    eventIsOpen: false,
    idCreatedBy: null,
    createdOn: "0001-01-01T00:00:00",
    idModifiedBy: null,
    modifiedOn: "0001-01-01T00:00:00",
    isPreEvent: false,
    eventTagId: null,
    eventTagDescription: null,
    preEventIdUserWinner: null,
    preEventWinnerUsername: null,
    preEventWinnerPrice: null,
    preEventCloseDate: null,
    inStore: false
  };
  isError: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private router: Router,
    private articleService: ArticleService,
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.searchCode = '';
  }


  searchCertificate() {
    this.searchCode = this.searchCode.replace(/\s/g, '');
    if(this.searchCode != '') {
      const lang = this.languageService.userSelectedLanguage.code;

      this.articleService.getArticleByCertificate(this.searchCode).subscribe((responseBody) => {
        if (responseBody == null) {
          this.isError = true;
        } else {
          this.isError = false;
          this.searchedAuction = responseBody;

          const infoList = this.searchedAuction.article.articleInfoList.find((info) => info.languageCode == lang);

          this.searchedAuction.article.articleInfoList = [infoList];

          this.router.navigate(['certificate/' + this.searchCode]);
          this.activeModal.close();
        }

      });
    }
  }

}
